import University from '../networking/models/University';

export const getUniversityUrlForSlug = (university: University, slug: string): string | undefined => {
    return university.socialMediaAccounts?.find(a => a.slug === slug)?.url;
};

interface Slugs {
    twitter: string;
    insta: string;
    facebook: string;
    web: string;
}

export const getUniversityUrls = (university: University): Slugs => {
    return university.socialMediaAccounts!.reduce((slugs, value) => {
        return { ...slugs, [value.slug]: value.url };
    }, { twitter: '', facebook: '', insta: '', web: '' });
};
